import { MessageBanner } from 'components/MessageBanner'
import React, { useState } from 'react'

import { useKeycloak } from './KeycloakProvider'
import { LoginPage } from './LoginPage'

type ContentSelectorProps = {
  children: React.JSX.Element
}

export const KeycloakAuthenticatedContent = ({
  children,
}: ContentSelectorProps) => {
  const { isLoading, isAuthenticated, sendToKeycloakLogin, error } =
    useKeycloak()

  if (isLoading) {
    return null
  }

  if (!isAuthenticated) {
    if (!error) {
      sendToKeycloakLogin()
    }

    return <LoginPage provider='keycloak' />
  }
  return children
}

// TODO: merge this with Auth0MessageBanner
export const KeycloakMessageBanner = () => {
  const { error } = useKeycloak()

  const [showBanner, setShowBanner] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  React.useEffect(() => {
    if (error) {
      setErrorMessage(`Error: ${error.message}`)
      setShowBanner(true)
    } else {
      setErrorMessage('')
      setShowBanner(false)
    }
  }, [error])

  return (
    <MessageBanner
      absolutePositionTop
      showBanner={showBanner}
      hideBanner={() => setShowBanner(false)}
      contents={
        <div>
          <div id={'banner-error-message'}>{errorMessage}</div>
          <div id={'banner-error-details'}>
            Having trouble logging in? Contact{' '}
            <a id={'banner-error-link'} href='mailto:support@geckorobotics.com'>
              support@geckorobotics.com
            </a>
          </div>
        </div>
      }
    />
  )
}
